import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	color: ${palette('white')};
	margin: 24px auto 24px;
	text-align: left;

	${minWidth('desktop')} {
		max-width: 50%;
	}

	ul {
		padding: 0;
		li {
			list-style: none;
		}
	}
`;

export const LoggedInAs = styled(Text)`
	margin-top: 24px;
	text-align: center;
`;

export const FooterLinks = styled.ul`
	display: flex;
	margin-top: 16px;
	justify-content: center;

	li {
		height: 24px;
		padding: 0 16px;
		display: flex;
		align-items: center;
		border-right: 1px ${palette('white')} solid;
		&:last-of-type {
			border-right: 0;
		}
	}
`;

export const FooterLink = styled.a`
	color: ${palette('white')};
	text-decoration: none;
`;
